import SuperOffer from "./SuperOffer";

export default SuperOffer;